import PropTypes from 'prop-types';

const InputType = PropTypes.shape({
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
  ]).isRequired,
  props: PropTypes.object,
  size: PropTypes.oneOf(['small', 'normal', 'wide']),
}).isRequired;

export default InputType;



// WEBPACK FOOTER //
// ./src/components/stateful/Modal/InputType.js